import axios from 'axios';

import { urlBuilder } from '@/plugins/helpers';

import store from '../store';
import router from '../router';

export function setUserData() {
  store.dispatch('setTrainerId');
  if (store.getters.isAdmin) store.dispatch('saveDaily', true);
  else store.dispatch('saveSelectedTrainerId', store.getters.trainerId);
}

export async function login(payload) {
  let response = {};
  let statusCode = null;

  try {
    response = (await axios.post(urlBuilder('/token/'), payload));
  } catch (error) {
    statusCode = error.response.status;
  }
  if (!statusCode) {
    store.commit('saveAccessToken', response.data.access);
    store.commit('saveRefreshToken', response.data.refresh);
    statusCode = response.status;
    setUserData();
  }
  if (store.getters.accessToken && store.getters.refreshToken) await router.push('/calendar');
  return statusCode;
}

export function logout() {
  store.commit('deleteAccessToken');
  store.commit('deleteRefreshToken');
  router.push('/');
}
